import { Button, Divider, Group, Radio, RadioGroup, Stack, Text } from "@mantine/core";
import { IconArrowRight, IconInfoCircle } from "@tabler/icons-react";
import { useState } from "react";

export const TopicCreateModal = ({ onSubmit }: { onSubmit: (required: boolean) => void }) => {
    const [radioValue, setRadioValue] = useState("standard");
    return (
        <Stack>
            <Group>
                <IconInfoCircle size={16} />
                <Text size="lg">Topic Type cannot be changed</Text>
            </Group>
            <Text>Once you create this topic, the selected topic type will be permanent and cannot be edited later.</Text>
            <Divider />
            <RadioGroup value={radioValue} onChange={setRadioValue}>
                <Stack>
                    <Radio value="standard" label="Standard" />
                    <Radio value="required" label="Required" />
                </Stack>
            </RadioGroup>
            <Button w="100%" rightSection={<IconArrowRight size={16} />} onClick={() => onSubmit(radioValue == "required")}>
                Continue
            </Button>
        </Stack>
    );
};
